module.exports = __webpack_public_path__ + "img/facebook-svgrepo-com.91783339.svg";